import { ChatBase } from "@Base/Engagement/Chat/ChatBase";
import { IQuiqOptions } from "@Base/Engagement/Chat/IQuiqOptions";
import { TextResource } from "@Utilities/TextResource";

export class Chat extends ChatBase
{
	constructor()
	{
		super();
	}

	public override GetSiteOptions(): IQuiqOptions
	{
		const primary = "#f06422";
		const primaryBorder = `1px solid ${primary}`;
		const secondary = "#221c1e";
		/*
		* These options are provided to the Quiq chat object on initialization.
		* NOTE: Chat options can be overridden at the site level for various look-and-feel details.
		*
		* See the full list of available options that can be configured for Quiq chat:
		* https://developers.goquiq.com/docs/webchat/#/reference/types
		*/
		const siteOptions: IQuiqOptions = {
			contactPoint: "halloweencom",
			colors: {
				primary: primary,
				agentMessageDropdownButtonBackground: primary,
				agentMessageLinkText: primary,
				customerMessageBackground: secondary,
				agentMessageText: secondary
			},
			styles: {
				HeaderMenu: {
					backgroundColor: primary,
					color: secondary,
					fontWeight: "600"
				},
				HeaderMenuIcons:
				{
					color: secondary
				},
				HeaderBanner: {
					backgroundColor: secondary,
					color: "#fff",
					fontWeight: "600"
				},
				WelcomeFormBanner:
				{
					backgroundColor: secondary
				},
				WelcomeFormSubmitButton: {
					borderColor: secondary,
					backgroundColor: secondary
				},
				AgentRichMessage: {
					button: {
						borderColor: secondary,
						color: secondary,
						fontWeight: "600",
						borderRadius: "50rem"
					}
				},
				InlineActionButton: {
					border: primaryBorder,
					color: primary
				},
				MessageFormInput: {
					color: secondary
				},
				MessageFormSend: {
					backgroundColor: primary,
					color: secondary,
					fontWeight: "600",
					borderRadius: "50rem"
				},
				OptionsMenuLineItem: {
					color: primary
				},
				OptionsMenuLineItemIcon: {
					color: primary
				}
			},
			messages: {
				headerText: TextResource.GetTextByCulture("Feature_Chat_AskAnythingSpooky")
			}
		};

		if (TextResource.GetLanguage() === "es")
		{
			siteOptions.language = "es";
		}

		return siteOptions;
	};
}